import React from 'react'
import {Link} from "~components"
import ProcessCard from './Components/Card'
import Process from './style'
import ProcessData from "~data/services/Process"
import { Container, Row, Col } from 'react-bootstrap'
export default function ProcessSection({ ...rest }){
return(
<Process backgroundColor="rgb(16,165,114)" {...rest}>
  <Container>
    <Row className="align-items-center justify-content-center justify-content-xl-start order-2 order-xl-1">
        <Col xs="12" className="col-xl-4 col-md-10 text-center text-xl-start">
            <Process.Box mt="20px" mtXL="0px">
              <Process.Subtitle as="h5">Наш процесс</Process.Subtitle>
              <Process.Title as="h2">Как это работает</Process.Title>
              <Process.Text as="p">Пройдите путь программиста<br className="d-none d-xs-block d-lg-none d-xl-block"></br> вместе с нами </Process.Text>
              <Process.Button className="btn-torch-red" to="/about/contact" as={Link}>Записаться</Process.Button>
            </Process.Box>
      </Col>
      <Col xs="12" className="col-xl-8 order-1 order-xl-2">
        <Process.Box as="div" className="widgets">
          <Row className="justify-content-center">
          {ProcessData.map(({title,text,icon,iconBackground, id})=>{
             return(
            <Col xs="12" className="col-lg-4 col-md-4 col-xs-6" key={id}>
               <ProcessCard icon={icon} title={title} text={text} />
            </Col>
               )
              })}
          </Row>
          </Process.Box>
      </Col>
    </Row>
  </Container>
</Process>

)
}